"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ClickAwayListener_1 = require("@material-ui/core/ClickAwayListener");
var core_1 = require("@material-ui/core");
var ClickableCustomTooltipStyles_1 = require("./ClickableCustomTooltipStyles");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var ClickableCustomTooltip = function (_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? 'right' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, translationId = _a.translationId, tooltipType = _a.tooltipType;
    var styles = ClickableCustomTooltipStyles_1.default();
    var _d = react_1.useState(false), tooltipOpen = _d[0], setTooltipOpen = _d[1];
    var openTooltip = react_1.useCallback(function (e) {
        e.stopPropagation();
        setTooltipOpen(true);
    }, []);
    return (<core_1.Box component="span" className={className}>
      <ClickAwayListener_1.default onClickAway={function () { return setTooltipOpen(false); }}>
        <core_1.Tooltip arrow={false} placement={placement} title={children} id="summaryTooltip" interactive={true} open={tooltipOpen} classes={{
        tooltip: styles.tooltipContainer,
        arrow: styles.tooltipArrow,
    }}>
          <core_1.IconButton onClick={openTooltip} data-test={"common:mui:tooltip:" + tooltipType} className={styles.tooltipIconButton} disableRipple={true}>
            <Translation_1.default id={translationId}/>
          </core_1.IconButton>
        </core_1.Tooltip>
      </ClickAwayListener_1.default>
    </core_1.Box>);
};
exports.default = ClickableCustomTooltip;
